import React from "react";
import { Paper, PaperProps, Typography } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { EarningsSummary } from "../../../../../../../services/earnings/types/earnings-summary";
import { Dinero } from "dinero.js";

interface EarningsSummaryProps extends PaperProps {
  summary: EarningsSummary[];
  loading: boolean;
}

export const EarningsSummaryComponent: React.FC<EarningsSummaryProps> = (
  props
) => {
  return (
    <Paper
      {...props}
      style={{ padding: "20px", overflow: "hidden", ...props.style }}
    >
      <Typography variant="h6">Earnings</Typography>

      <div style={{ display: "flex", height: "600px", marginTop: "20px" }}>
        <DataGrid
          rows={props.summary}
          loading={props.loading}
          columns={[
            { field: "streamsDate", headerName: "Streams Date", width: 250 },
            { field: "dsp", headerName: "DSP", width: 400 },
            {
              field: "quantity",
              headerName: "Streams",
              width: 300,
              type: "number",
            },
            {
              field: "value",
              headerName: "Earnings",
              width: 400,
              type: "number",
              valueFormatter: (params) => (params.value as Dinero).toFormat(),
            },
          ]}
          pageSize={100}
        />
      </div>
    </Paper>
  );
};
